var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDebtSalesStatistic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 77,
    viewBox: "0 0 79 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.7891 46.2793H26.6504V52.4182H32.7891V46.2793Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8154 13.9434V56.7891H38.0645V13.9434H57.8154Z",
    fill: "url(#paint0_linear_3002_12074)",
    fillOpacity: 0.2,
    stroke: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1785 13.4434H44.8711V29.3248H52.1785V13.4434Z",
    fill: "url(#paint1_linear_3002_12074)",
    fillOpacity: 0.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8704 14.6163H37.563C36.8812 14.6163 36.2969 14.0319 36.2969 13.3501C36.2969 12.6684 36.8812 12.084 37.563 12.084H44.8704C45.5522 12.084 46.1366 12.6684 46.1366 13.3501C46.1366 14.029 45.5522 14.6163 44.8704 14.6163Z",
    fill: "url(#paint2_linear_3002_12074)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3147 58.4593H37.561C36.8793 58.4593 36.2949 57.8749 36.2949 57.1931C36.2949 56.5114 36.8793 55.927 37.561 55.927H57.0456V14.6163H52.173C51.4912 14.6163 50.9069 14.0319 50.9069 13.3501C50.9069 12.6684 51.4912 12.084 52.173 12.084H58.3117C58.9935 12.084 59.5778 12.6684 59.5778 13.3501V57.1931C59.4834 57.8749 58.899 58.4593 58.3147 58.4593Z",
    fill: "url(#paint3_linear_3002_12074)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5636 58.4593H2.29541C1.61366 58.4593 1.0293 57.8749 1.0293 57.1931V13.3501C1.0293 12.6684 1.61366 12.084 2.29541 12.084H18.079C18.7608 12.084 19.3451 12.6684 19.3451 13.3501C19.3451 14.0319 18.7608 14.6163 18.079 14.6163H3.46413V56.0244H36.3949V14.6163H27.8184C27.1366 14.6163 26.5523 14.0319 26.5523 13.3501C26.5523 12.6684 27.1366 12.084 27.8184 12.084H37.5606C38.2424 12.084 38.8268 12.6684 38.8268 13.3501V57.1931C38.8297 57.8749 38.2454 58.4593 37.5636 58.4593Z",
    fill: "url(#paint4_linear_3002_12074)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1751 30.4921H44.8677C44.1859 30.4921 43.6016 29.9078 43.6016 29.226V13.4419C43.6016 12.7602 44.1859 12.1758 44.8677 12.1758H52.1751C52.8569 12.1758 53.4412 12.7602 53.4412 13.4419V29.3234C53.4412 29.9107 52.8569 30.4921 52.1751 30.4921ZM46.1367 28.0572H51.0094V14.6107H46.1367V28.0572Z",
    fill: "url(#paint5_linear_3002_12074)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9498 36.5363C22.5603 36.5363 22.2681 36.3415 21.9759 36.0493L12.2336 23.8718C11.9414 23.4823 11.8441 22.9953 12.0388 22.6057C12.2336 22.2161 12.6232 21.9239 13.1102 21.9239H16.8111V1.27005C16.8111 0.588281 17.3955 0.00390625 18.0772 0.00390625C18.759 0.00390625 19.3433 0.588281 19.3433 1.27005V23.193C19.3433 23.8748 18.759 24.4592 18.0772 24.4592H15.7398L22.9498 33.4226L30.1599 24.4592H27.8225C27.1407 24.4592 26.5563 23.8748 26.5563 23.193V6.14281C26.5563 5.46104 27.1407 4.87666 27.8225 4.87666C28.5042 4.87666 29.0886 5.46104 29.0886 6.14281V21.9269H32.6921C33.1791 21.9269 33.5687 22.2191 33.7634 22.6087C33.9582 22.9982 33.8608 23.4852 33.5687 23.8748L23.9238 36.0493C23.6316 36.3415 23.3394 36.5363 22.9498 36.5363Z",
    fill: "url(#paint6_linear_3002_12074)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9478 19.4851C22.266 19.4851 21.6816 18.9007 21.6816 18.219V1.26615C21.6816 0.584379 22.266 0 22.9478 0C23.6295 0 24.2139 0.584379 24.2139 1.26615V18.3164C24.2139 18.9007 23.6295 19.4851 22.9478 19.4851Z",
    fill: "url(#paint7_linear_3002_12074)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0352 37.7402C68.4627 37.7402 72.862 42.1365 72.8623 47.5674C72.8623 52.9922 68.4633 57.3955 63.0352 57.3955C57.6076 57.3954 53.2051 52.9925 53.2051 47.5674C53.2053 42.1393 57.608 37.7404 63.0352 37.7402Z",
    fill: "url(#paint8_linear_3002_12074)",
    stroke: "#F7F7FA",
    strokeWidth: 2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1514 56.2285C73.2875 56.2285 77.4473 60.393 77.4473 65.5283V70.5566H57.8857L57.8662 69.5752C57.7873 65.4677 55.5822 61.8751 52.3008 59.8408L51.083 59.085L52.2119 58.2021C53.7838 56.9737 55.7696 56.2286 57.9277 56.2285H68.1514ZM60.3115 65.7881L60.957 61.541L60.1445 60.043L59.6357 59.1055H59.04L60.3115 65.7881ZM65.917 60.043L65.1035 61.54L65.75 65.7812L67.0205 59.1055H66.4258L65.917 60.043Z",
    fill: "url(#paint9_linear_3002_12074)",
    stroke: "#F7F7FA",
    strokeWidth: 2
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4043 37.7402C20.8345 37.7402 25.2341 42.1363 25.2344 47.5674C25.2344 52.9924 20.8351 57.3955 15.4043 57.3955C9.97903 57.3954 5.58008 52.9919 5.58008 47.5674C5.58034 42.1399 9.9794 37.7403 15.4043 37.7402Z",
    fill: "url(#paint10_linear_3002_12074)",
    stroke: "#F7F7FA",
    strokeWidth: 2
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5166 56.2285C22.6849 56.2285 24.6708 56.9777 26.251 58.2148L27.377 59.0967L26.1621 59.8516C22.8896 61.8853 20.6949 65.4699 20.6133 69.5762L20.5938 70.5566H1V65.5283C1 60.3963 5.15961 56.2286 10.2959 56.2285H20.5166ZM18.29 60.0469L17.4756 61.5439L18.1221 65.7949L19.3965 59.1084H18.8008L18.29 60.0469ZM12.6826 65.7793L13.3281 61.54L12.5146 60.0479L12.002 59.1084H11.4102L12.6826 65.7793Z",
    fill: "url(#paint11_linear_3002_12074)",
    stroke: "#F7F7FA",
    strokeWidth: 2
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2227 32.0117C46.4218 32.0117 52.25 37.8466 52.25 45.042C52.2498 52.2403 46.4215 58.0713 39.2227 58.0713C32.0273 58.0712 26.1936 52.2407 26.1934 45.042C26.1934 37.8464 32.0239 32.0119 39.2227 32.0117Z",
    fill: "url(#paint12_linear_3002_12074)",
    stroke: "#F7F7FA",
    strokeWidth: 2
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1826 57.207C52.9795 57.207 58.4921 62.716 58.4922 69.5137V76H19.9492V69.5137C19.9493 62.7193 25.4616 57.207 32.2559 57.207H46.1826ZM35.5547 72.0068L36.8125 63.7529L38.79 64.0537L37.5742 72.0615H42.873L45.0947 60.3994H33.3467L35.5547 72.0068Z",
    fill: "url(#paint13_linear_3002_12074)",
    stroke: "#F7F7FA",
    strokeWidth: 2
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6406 60.3887L42.8359 61.8672L41.666 64.0137L43.0205 72.9111L43.1953 74.0615H35.248L35.4238 72.9111L36.7754 64.0166L35.6074 61.8662L34.8047 60.3887H43.6406Z",
    fill: "url(#paint14_linear_3002_12074)",
    stroke: "#F7F7FA",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3002_12074",
    x1: 38.2759,
    y1: 13.4434,
    x2: 64.5602,
    y2: 17.3375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D60FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#539BFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3002_12074",
    x1: 45.1216,
    y1: 13.4434,
    x2: 54.3887,
    y2: 14.7782,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D60FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#539BFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3002_12074",
    x1: 36.6342,
    y1: 12.084,
    x2: 41.771,
    y2: 18.3323,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D60FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#539BFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3002_12074",
    x1: 37.0932,
    y1: 12.084,
    x2: 66.5058,
    y2: 16.7066,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D60FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#539BFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3002_12074",
    x1: 2.32521,
    y1: 12.084,
    x2: 48.2626,
    y2: 23.8046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D60FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#539BFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3002_12074",
    x1: 43.9389,
    y1: 12.1758,
    x2: 56.3258,
    y2: 14.2589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D60FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#539BFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3002_12074",
    x1: 12.6893,
    y1: 0.00390481,
    x2: 40.1057,
    y2: 5.15531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D60FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#539BFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3002_12074",
    x1: 21.7685,
    y1: -7.6866e-7,
    x2: 25.0409,
    y2: 0.133132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D60FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#539BFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3002_12074",
    x1: 54.8105,
    y1: 38.7402,
    x2: 75.6274,
    y2: 45.2578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D60FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#539BFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_3002_12074",
    x1: 53.6379,
    y1: 57.2285,
    x2: 76.1239,
    y2: 70.7149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D60FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#539BFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_3002_12074",
    x1: 7.18538,
    y1: 38.7402,
    x2: 27.9994,
    y2: 45.2558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D60FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#539BFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_3002_12074",
    x1: 2.81031,
    y1: 57.2285,
    x2: 25.3029,
    y2: 70.7273,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D60FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#539BFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_3002_12074",
    x1: 28.0181,
    y1: 33.0117,
    x2: 56.3797,
    y2: 41.8889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D60FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#539BFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_3002_12074",
    x1: 22.2021,
    y1: 58.207,
    x2: 54.513,
    y2: 80.2172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D60FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#539BFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_3002_12074",
    x1: 36.6048,
    y1: 61.3887,
    x2: 43.7173,
    y2: 62.4605,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D60FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#539BFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDebtSalesStatistic);
export default __webpack_public_path__ + "static/media/debt-sales-statistic.213a49fcc6429fb9060f1070434e02b8.svg";
export { ForwardRef as ReactComponent };